import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import PopupModal from "../../PopupModal";
import { displayNotification, sendAPIRequest } from "helpers";
import { FaCheck, FaPlus } from "react-icons/fa";
import { Button } from "@mui/material";
import DropdownField from "../../core/DropdownField";
import TextAreaField from "../../core/TextAreaField";
import { defaultSingleCCDataTemplate } from "modules/pvs_activities/constants";
import { useLazyGetTempCCQuery } from "modules/pvs_activities/redux/service/common";
import { useUpdateCCDataMutation } from "modules/pvs_activities/redux/service/dForm";
import { FormDataContext } from "../../contexts/FormContext";

const DynamicCCListAddNewModal = (props) => {
    const formDataContext = useContext(FormDataContext);
    const modalRef = useRef();

    const [data, setData] = useState({ ...defaultSingleCCDataTemplate });
    const [keyDataTrigger, keyDataRes] = useLazyGetTempCCQuery();
    const [updateCCData, updateCCDataRes] = useUpdateCCDataMutation();

    useEffect(() => {
        if (keyDataRes.isError) {
            displayNotification("error", `Error Loading Key ${props.type}`);
        }
    }, [keyDataRes]);

    useEffect(() => {
        if (updateCCDataRes.isError) {
            displayNotification("error", `Error saving Critical Competency ${props.type} data.`);
            console.log({ error: updateCCDataRes.error });
        }
    }, [updateCCDataRes]);

    const keyData = useMemo(() => {
        if (keyDataRes.isSuccess) return keyDataRes.data.map((r) => ({ value: r.id, label: r.text }));
        return [];
    }, [keyDataRes]);

    const handleSave = () => {
        if (formDataContext.mode === "data_entry") {
            updateCCData({
                template_id: formDataContext.templateId,
                section_id: formDataContext.sectionId,
                element_id: props.elementId,
                movement_id: formDataContext.movementId,
                cc_id: props.ccId,
                key: props.listKey,
                ...data,
            });
        } else {
            props.onChange(data);
        }
        setData({ ...defaultSingleCCDataTemplate });
        modalRef.current?.closeModal();
        displayNotification("success", "Sucessfully added to list");
    };

    return (
        <PopupModal
            ref={modalRef}
            title={`Add New ${props.type}`}
            triggers={({openModal}) => (
                <Button
                    variant={"contained"}
                    color={"primary"}
                    onClick={openModal}
                    className={props.className}
                    size={props.size}
                >
                    <FaPlus />
                    <span className="ms-1">Add new entry</span>
                </Button>
            )}
            footTriggers={() => (
                <Button
                    variant="contained"
                    color="success"
                    disableElevation={true}
                    title="Add to List"
                    onClick={handleSave}
                    sx={{ minWidth: 45 }}
                    disabled={props.disabled}
                >
                    <FaCheck />
                    <span className="ms-1">Add to List</span>
                </Button>
            )}
            onOpen={() => {
                keyDataTrigger(props.type);
                setData({...data, id: Math.ceil(Math.random() * 10000)});
            }}
        >
            <>
                <TextAreaField
                    label={`Write your own text`}
                    type={"text"}
                    value={data.content}
                    onChange={(val) => setData({ ...data, content: val })}
                    error={data.length >= 500}
                    multiline
                    minRows={5}
                    maxRows={10}
                    sx={{ width: "100%" }}
                />
                <DropdownField
                    plain={true}
                    label={`Select Key ${props.type}`}
                    value={data.key_value_id}
                    onChange={(val, obj) => setData({ ...data, key_value_id: val, key_value_text: obj.label })}
                    hasOptions={true}
                    options={keyData}
                    marginTop="10px"
                />
            </>
        </PopupModal>
    );
};

DynamicCCListAddNewModal.defaultProps = {
    listKey: "strengths",
    type: "Strengths",
    elementId: "",
    ccId: "",
    className: "",
    size: "normal",
    onChange: () => {},
};

export default DynamicCCListAddNewModal;
